export const APP_VERSION = process.env.VUE_APP_VERSION;
export const PLUGIN_ID = process.env.VUE_APP_PLUGIN_ID;
// export const LIFECYCLE_CHANNEL = `${PLUGIN_ID.toUpperCase()}-LIFECYCLE`;

export const SUGGESTION_LOCAL = 'LOCAL';
export const SUGGESTION_LIVE = 'LIVE';

export const DOMAINS = {
  NCOS: 'NCOS',
};
